const o = {
  modelValue: {
    type: Array,
    default: () => {
    }
  },
  tag: {
    type: String,
    default: "div"
  },
  disabled: Boolean
}, e = Symbol("checkboxGroupContextKey");
export {
  e as checkboxGroupContextKey,
  o as checkboxGroupProps
};
